// Card image dimensions should be 315x250

export const projects =
[
    // -------- Featured --------
    {
        key:"untamed-isles",
        description:"Monster taming MMO worked on whilst at Phat Loot Studios",
        image: "/images/untamed-isles/card-untamed-isles.png",
        slug: "untamed-isles",
        group: "Featured",
    },
    {
        key:"are-ya-winning-son",
        description:"Entry to Aotearoa Game Jam 2022",
        image: "/images/are-ya-winning-son/card-are-ya-winning-son.png",
        slug: "are-ya-winning-son",
        group: "Featured",
    },
    {
        key:"bills-bussin-buffet",
        description:"Entry to the game jam Kiwi Jam 2022",
        image: "/images/bills-bussin-buffet/card-bills-bussin-buffet.png",
        slug: "bills-bussin-buffet",
        group: "Featured",
    },
    {
        key:"simpli",
        description:"A local and central government portal developed to digitize the building consent process",
        image: "/images/simpli/card-simpli.png",
        slug: "simpli",
        group: "Featured",
    },
    {
        key:"nuwave",
        description:"A platform developed enabling generic B2B and B2C digital workflows",
        image: "/images/nuwave/card-nuwave.png",
        slug: "nuwave",
        group: "Featured",
    },
    {
        key:"grandmas-special-boy",
        description:"A online competitive dress up game developed for mobile devices",
        image: "/images/grandmas-special-boy/card-grandmas-special-boy.png",
        slug: "grandmas-special-boy",
        group: "Featured",
    },
    {
        key:"why-does-no-one-love-me",
        description:"Entry to the Game Developers League Christmas game jam",
        image: "/images/why-does-no-one-love-me/card-why-does-no-one-love-me.png",
        slug: "why-does-no-one-love-me",
        group: "Featured",
    },
    {
        key:"climb-princess-climb",
        description:"Entry to the Game Developers League July game jam ",
        image: "/images/climb-princess-climb/card-climb-princess-climb.png",
        slug: "climb-princess-climb",
        group: "Featured",
    },


    // -------- Other --------
    {
        key:"return-to-frogge",
        description:"Entry to an internal Phat Loot game jam",
        image: "/images/return-to-frogge/card-return-to-frogge.png",
        slug: "return-to-frogge",
        group: "Other",
    },
    {
        key:"who-cares-if-its-buggy",
        description:"Entry to the Ludum Dare 45 game jam",
        image: "/images/who-cares-if-its-buggy/card-who-cares-if-its-buggy.png",
        slug: "who-cares-if-its-buggy",
        group: "Other",
    },
    {
        key:"experiments",
        title: "Experiments",
        description:"An assortment of random experiments",
        image: "/images/experiments/card-experiments.gif",
        slug: "experiments",
        group: "Other",
    },
    {
        key:"visceral",
        title: "Visceral",
        description:"A multiplayer PVP game with a focus on customizable magic spells",
        image: "/images/visceral/card-visceral.png",
        slug: "visceral",
        group: "Other",
        gradient: true
    },
    {
        key:"one-in-one-out",
        title: "One In One Out",
        description:"A machine learning project attempting to simulate the COVID-19 grocery shopping experience in New Zealand",
        image: "/images/one-in-one-out/card-one-in-one-out.png",
        icon: ["fas", "shopping-cart"],
        slug: "one-in-one-out",
        group: "Other",
    },
    {
        key:"networking-library",
        title: "Networking Library",
        description:"A high level networking API developed for another game project",
        image: "/images/networking-library/card-networking-library.png",
        icon: ["fas", "network-wired"],
        slug: "networking-library",
        group: "Other",
    },
    {
        key:"flappy-kyata",
        title: "Flappy Kyata",
        description:"A satirical 'Flappy Bird' clone starring my sister as the protagonist",
        image: "/images/flappy-kyata/card-flappy-kyata.png",
        slug: "flappy-kyata",
        group: "Other",
        gradient: true
    },

    // -------- OLD --------
    // {
    //     key:"screeps",
    //     description:"My attempt at playing the scripting based game 'Screeps'",
    //     title: "Screeps",
    //     image: "/images/screeps/card-screeps.png",
    //     slug: "screeps",
    //     group: "Other",
    //     gradient: true
    // },
    // {
    //     key:"givey",
    //     title: "Givey",
    //     description:"A platform developed to assist offering and requesting charitable donations",
    //     image: "/images/givey/card-givey.png",
    //     icon: ["fas", "hand-holding-usd"],
    //     slug: "givey",
    //     group: "Other",
    // },
    // {
    //     key:"cat-cat-magic-attack",
    //     title: "Cat Cat Magic Attack",
    //     description:"A game about cats and students at a magical school",
    //     image: "/images/cat-cat-magic-attack/card-cat-cat-magic-attack.png",
    //     slug: "cat-cat-magic-attack",
    //     group: "Other",
    //     gradient: true
    // },
    // {
    //     key:"portfolio-site",
    //     title: "Portfolio Site",
    //     description:"This portfolio site (:",
    //     image: "/images/portfolio-site/card-portfolio-site.png",
    //     icon: ["fas", "address-card"],
    //     slug: "portfolio-site",
    //     group: "Other",
    // },
    // {
    //     key:"shank-the-world",
    //     title: "Shank The World",
    //     description:"A multiplayer RPG game developed for a university assignment",
    //     image: "/images/shank-the-world/card-shank-the-world.png",
    //     slug: "shank-the-world",
    //     group: "2015",
    //     gradient: true
    // },
    // {
    //     key:"dungeon-crawler",
    //     title: "Dungeon Crawler",
    //     description:"A 'Binding of Isaac' inspired game developed for a university assignment",
    //     image: "/images/dungeon-crawler/card-dungeon-crawler.png",
    //     slug: "dungeon-crawler",
    //     group: "2016",
    //     gradient: true
    // },
];

export const groups =
[
    {
        key: "Featured",
        prio: 3,
    },
    {
        key: "Other",
        prio: 1,
    },
    {
        key: "2021",
        prio: 2,
    },
];